import type { SummaryContext } from "../pages/inbound/shared/ActionsMenuContext";

/**
 * Filters selections to only include shipment content based on drag context
 * When dragging from unassigned bucket, route/trap selections should contribute
 * their shipment content but not be treated as source containers
 */
export const getShipmentIdsFromSelection = (
  selection: SummaryContext[],
  _dragSourceType: string
): number[] => selection.flatMap((item) => item.shipmentIds);

/**
 * Determines if a selection should be treated as a source container
 * based on the drag context
 */
export const isValidSourceContainer = (
  selection: SummaryContext,
  dragSourceType: string
): boolean => {
  if (dragSourceType === "unassigned") {
    return selection.type === "shipment" || selection.type === "bucket";
  }

  return true;
};

/**
 * Filters selections to only include those that should be treated as source containers
 */
export const filterValidSourceContainers = (
  selection: SummaryContext[],
  dragSourceType: string
): SummaryContext[] =>
  selection.filter((item) => isValidSourceContainer(item, dragSourceType));
